<template>
  <div>
    <ReportStatStaticCard
      :points="meta.reports"
      :metrics="metrics"
      :selectedIndex="selectedMetricIndex"
      @onClick="onMetricClick"
    />
    <div class="search_container mt_16">
        <SearchInput
        :placeholder="$t('CAMPAIGN.FILTERS.SEARCH_PLACEHOLDER')"
        v-model="searchText"
        @search="searchOrders"
        />
    </div>
    <section class="filter_bars">
      <div class="filter_bar">
        <p class="input_label">{{$t('ORDER.LIST_TABLE.DATE.LABEL')}}</p>
        <date-range-picker
          :confirm-text="$t('ORDER.LIST_TABLE.DATE_SELECT_CONFIRM_BTN')"
          :placeholder="$t('ORDER.LIST_TABLE.DATE.PLACEHOLDER')"
          class="font_normal order_start_date"
          :value="dateRange"
          @change="handleDateChange"
          :disabledDate="disableFilterDate"
        />
      </div>
      <div class="filter_bar">
        <p class="input_label">{{$t('CAMPAIGN.FILTERS.STATUS')}}</p>
        <multiselect
          v-model="selectedOrderStatuses"
          :options="OrderStatusList"
          class="small-12 font_normal"
          track-by="id"
          label="title"
          :multiple="true"
          :close-on-select="true"
          :clear-on-select="false"
          :hide-selected="true"
          :placeholder="$t('CAMPAIGN.FILTERS.STATUS_PLACEHOLDER')"
          selected-label
          :select-label="''"
          :deselect-label="$t('FORMS.MULTISELECT.ENTER_TO_REMOVE')"
          @select="applyFilterByStatuses($event)"
        />
      </div>
      <!-- <div class="filter_bar">
        <p class="input_label">{{$t('CAMPAIGN.FILTERS.SORT_BY')}}</p>
        <multiselect
          v-model="sortBy"
          :options="sortByList"
          class="small-12 font_normal"
          track-by="id"
          label="title"
          :multiple="false"
          :close-on-select="true"
          :clear-on-select="false"
          :hide-selected="true"
          :placeholder="$t('CAMPAIGN.FILTERS.SORTBY_PLACEHOLDER')"
          selected-label
          :select-label="''"
          :deselect-label="$t('FORMS.MULTISELECT.ENTER_TO_REMOVE')"
          @select="applyFilterBySortBy($event)"
        />
      </div> -->

    </section>

    <ContactOrderTable
      :cols="cols"
      :isLoading="uiFlags.isFetching"
      :records="records"
      :showEmptyResult="!uiFlags.isFetching && !records.length"
      @on-sort-change="onSortChange"
    />

    <div class="loadMore_btn" v-if="!uiFlags.isFetching">
      <woot-button
        variant="clear"
        size="small"
        color-scheme="primary"
        :is-loading="uiFlags.isFetching"
        :is-disabled="paginationCompute.isLastPage"
        @click="onPageChange(Number(meta.currentPage)+1)"
      >
        {{paginationCompute.btnText}}
      </woot-button>
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import helperMixin from 'shared/mixins/helperMixin';
import alertMixin from 'shared/mixins/alertMixin';
import DateRangePicker from "components/ui/DateRangePicker.vue"
import moment from "moment";
import TableFooter from 'dashboard/components/widgets/TableFooter';
import SearchInput from 'dashboard/components/ui/SearchInput.vue'
import ContactOrderTable from "./ContactOrderTable.vue"
import {CONTACT_ORDER_METRIC} from "./contact_constant"
import {ORDER_STATUSES} from "dashboard/routes/dashboard/catalogue/orders/order_constant.js"
import ReportStatStaticCard from "dashboard/routes/dashboard/settings/campaigns/broadcastAgent/ReportStatStaticCard.vue"

export default {
  components:{
    DateRangePicker,
    TableFooter,
    SearchInput,
    ContactOrderTable,
    ReportStatStaticCard,
  },
  mixins:[helperMixin,alertMixin],
  props:{
    contactId:{
      type: Number,
      required: true,
    },
  },
  data(){
    const endDate = new Date(); // Current date
    const startDate = new Date();
    startDate.setMonth(startDate.getMonth() - 1); // One month ago

    return {
      dateRange: [startDate,endDate],
      searchText: '',
      selectedOrderStatuses: [],
      sortInfo:{},
      // sortBy:null,
      // records:[],  // dummy records
      selectedMetricIndex: 999,  // no need active so invalid index
    }
  },
  computed:{
    ...mapGetters({
        currentUser: 'getCurrentUser',
        uiFlags: "orders/getUIFlags",
        meta: "orders/getMeta",
        records: "orders/getPaginatedOrders",
    }),
    paginationCompute(){
        const totalPages = Math.ceil(this.meta.count / this.meta.pageSize);
        const isLastPage = this.meta.currentPage >= totalPages;
        const currentCount = Math.min(this.meta.currentPage * this.meta.pageSize, this.meta.count);
        // const btnText = `Load More Orders (${currentCount}/${this.meta.count})`;
        const btnText = `${this.$t('CAMPAIGN.LLM_CHATBOT.REPORT.LOAD_MORE_BTN')} (${currentCount}/${this.meta.count})`;

        return{
            isLastPage,
            btnText,
        }
    },
    cols(){
      const cols = [
        { key: 'order_id', name: 'Order Id', visible: true, type: 'default' },
        { key: 'order_status', name: 'Order Status', visible: true, type: 'default' },
        { key: 'order_total', name: 'Order Total', visible: false, type: 'default' },
        { key: 'grand_total', name: 'Order Amount', visible: true, type: 'default' },
        { key: 'courier_fee', name: 'Courier fee', visible: true, type: 'default' },
        { key: 'courier_number', name: 'Courier number', visible: true, type: 'default' },
        { key: 'tracking', name: 'Tracking', visible: true, type: 'default' },
        { key: 'name', name: 'Name', visible: true, type: 'default' },
        { key: 'phone_number', name: 'Phone Number', visible: true, type: 'default' },
        { key: 'created_at', name: 'Created At', visible: true, type: 'default' },

        { key: 'paid_total', name: 'Paid Amount', visible: true, type: 'default' },
        { key: 'refund_amount', name: 'Refunded Amount', visible: true, type: 'default' },
        { key: 'line1', name: 'Line1', visible: true, type: 'default' },
        { key: 'line2', name: 'Line2', visible: false, type: 'default' },
        { key: 'city', name: 'City', visible: true, type: 'default' },
        { key: 'state', name: 'State', visible: false, type: 'default' },
        { key: 'postalCode', name: 'PostalCode', visible: false, type: 'default' },
        { key: 'country', name: 'Country', visible: false, type: 'default' },
      ]

      return cols;
    },
    OrderStatusList(){
      // return AI_CAMPAIGN_STATUS.map(el=>({...el,title:this.$t(el.title)}))
      return ORDER_STATUSES;
    },
    // sortByList(){
    //   // return AI_CAMPAIGN_SORT_LIST.map(el=>({...el,title:this.$t(el.title)}))
    //   return []
    // },
    metrics() {
      return CONTACT_ORDER_METRIC.map(el=>({...el,NAME:this.$t(el.NAME)}));
    // const metricList = [
    //   {
    //     NAME:"Order",
    //     KEY:"total_order",
    //     DESC:"( total )",
    //   },
    //   {
    //     NAME:"Completed",
    //     KEY:"total_completed",
    //     DESC:"( total )",
    //   },
    //   {
    //     NAME:"Amount",
    //     KEY:"total_amount",
    //     DESC:"( total )",
    //   },
    // ]
    //   return metricList;
    },
  },
  mounted() {
    this.$store.dispatch("orders/getOrdersByContact",{
      start_date: this.formatStartEndDate(this.dateRange[0],this.dateRange[1]).start_date,
      end_date: this.formatStartEndDate(this.dateRange[0],this.dateRange[1]).end_date,
      contact_id: this.contactId,
    });
    // When revisiting the route (with <keep-alive>)
    // this.getRecordList({
    //   page: 1,
    //   start_date: this.formatStartEndDate(this.dateRange[0],this.dateRange[1]).start_date,
    //   end_date: this.formatStartEndDate(this.dateRange[0],this.dateRange[1]).end_date,
    // });
  },
  methods:{
    // async getRecordList(newQuery={}){
    //   try {
    //     const defautQuery = {
    //       page: this.meta.currentPage,
    //       pageSize:  this.meta.pageSize,
    //       contact_id: this.contactId,
    //       q: this.searchValue,
    //       status: this.selectedStatus?.id,
    //       // order: this.sortBy?.order,
    //       // direction: this.sortBy?.direction,
    //       start_date: this.formatStartEndDate(this.dateRange[0],this.dateRange[1]).start_date,
    //       end_date: this.formatStartEndDate(this.dateRange[0],this.dateRange[1]).end_date,
    //       ...newQuery,
    //     }
    //     this.$store.dispatch("orders/getOrders",this.cleanObject(defautQuery));
    //   } catch (error) {
    //     console.log(error);
    //     this.showErrAlert(error,this.$t('CAMPAIGN.NETWORK_ERR.FETCH_ERR'));
    //   }
    // },
    async handleDateChange(dateRange) {
      this.dateRange = dateRange;
      const date = this.formatStartEndDate(dateRange[0],dateRange[1]);
      await this.$store.dispatch("orders/getOrdersByContact",{
        start_date: date.start_date,
        end_date: date.end_date,
        contact_id: this.contactId,
      });

      this.onPageChange(1)
      // this.getRecordList({
      //   page: 1,
      //   start_date: date.start_date,
      //   end_date: date.end_date,
      // })
    },
    disableFilterDate(date, currentValues) {
      return false; // no disable any date
    },
    onPageChange(page,option={}) {
      // console.log("ck",{statusFil:this.selectedOrderStatuses});

      this.$store.dispatch("orders/getPaginatedOrders",{
        currentPage:page,
        pageSize:this.meta.pageSize,
        searchText: this.searchText,
        sortBy: this.sortInfo.sortBy,
        sortOrder: this.sortInfo.sortOrder,
        statuesList: option.statuesList || this.selectedOrderStatuses.map(el=>el.id)
      })
    },
    onSortChange(params){
      const {order_id,...rest} = params;
      const newParams = {...rest,id:order_id}
      let newSort = {
        sortBy: 'id',  // default sort
        sortOrder: 'desc'
      }
      Object.keys(newParams).forEach(key=>{
        if (newParams[key]) {
          newSort.sortBy = key;
          newSort.sortOrder = newParams[key];
        }
      })
      this.sortInfo = newSort;
      this.onPageChange(1)
    },
    applyFilterByStatuses(selectedOption){
      const statuesList = [...this.selectedOrderStatuses,selectedOption].map(el=>el.id);
      this.onPageChange(1,{statuesList})
    },
    applyFilterRemoveStatus(selectedOption){
      const statuesList = this.selectedOrderStatuses
      .filter(el=>el.id !== selectedOption.id)
      .map(el=>el.id);
      this.onPageChange(1,{statuesList})
    },
    // applyFilterBySortBy(selectedOption){
    //   this.sortBy = selectedOption;
    //   this.getRecordList({
    //       order: selectedOption.order,
    //       direction: selectedOption.direction,
    //   });
    // },
    // onSearch(value){
    //   this.getRecordList({q:value,page:1});
    // },
    searchOrders() {
      this.onPageChange(1)
    },
    onMetricClick(index) {
        // this.selectedMetricIndex = index;
        // this.fetchChartData();
    },
    // end
  },

}
</script>



<style scoped lang="scss">
.search_container{
  max-width: 280px;
}
.filter_bars{
  display: flex;
  gap: 12px;
  margin-top: 16px;
  .filter_bar{
    p{
      margin-bottom: 8px;
    }
  }
}
.loadMore_btn button{
  display: block;
  margin: auto;
}
</style>